import React, { useState } from "react";

import "../../../assets/styles/ProductStyles/AllProductStyles/Allproduct.css";
import All_Products_Table from "./SubComponent/AllProducts_Table/All_Products_Table";
import Trending_Products from "./SubComponent/Trending_Products/Trending_Products";
import Hight_Demand from "./SubComponent/Hight_Demand/Hight_Demand";

const AllProducts = () => {
  const [showAllProductTable, setShowAllProductTable] = useState(true);
  const [showAllTrendingProductTable, setShowAllTrendingProductTable] =
    useState(true);
  const [changeIcon, setChangeIcon] = useState(""); // "Edit","Save"
  const [activeTab, setActiveTab] = useState("all"); // "all", "trending", "highDemand"

  return (
    <div className="w-[80vw]">
      {/* Tabs for Categories */}
      <div className="flex items-center gap-7 px-3 mb-4 text-xl font-semibold text-gray-500">
        <div
          className={`cursor-pointer ${
            activeTab === "all"
              ? "text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4"
              : "text-gray-500 hover:text-[#FF0000] "
          }`}
          onClick={() => {
            setActiveTab("all");
            setChangeIcon("");
          }}
        >
          All
        </div>
        <div
          className={`cursor-pointer ${
            activeTab === "trending"
              ? "text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4"
              : "text-gray-500 hover:text-[#FF0000] "
          }`}
          onClick={() => {
            setActiveTab("trending");
            setChangeIcon("");
          }}
        >
          Trending Products
        </div>
        <div
          className={`cursor-pointer ${
            activeTab === "highDemand"
              ? "text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4"
              : "text-gray-500 hover:text-[#FF0000] "
          }`}
          onClick={() => {
            setActiveTab("highDemand");
            setChangeIcon("Edit");
          }}
        >
          High Demand / Hot Enquiries
        </div>
      </div>

      {/* Tables Based on Active Tab */}
      <div className="px-3 mb-4">
        {activeTab === "all" && (
          <>
            {showAllProductTable && (
              <>
                <All_Products_Table />
              </>
            )}
          </>
        )}
        {activeTab === "trending" && (
          <>
            {showAllTrendingProductTable && (
              <>
                <Trending_Products />
              </>
            )}
          </>
        )}

        {activeTab === "highDemand" && (
          <>
            <Hight_Demand />
          </>
        )}
      </div>
    </div>
  );
};

export default AllProducts;
